import { useEffect } from 'react'
// import HeaderImage1 from '../../assets/professional_headshot_Mar2026.png'
import HeaderImage1 from '../../assets/hs_graduation.jpg'
import HeaderImage2 from '../../assets/setup2-min.jpg'
import HeaderImage3 from '../../assets/lfmn-min.png'
import HeaderImage4 from '../../assets/costa_rica.jpg'
import HeaderImage5 from '../../assets/stcloudstate1-enhanced-min.jpeg'
import data from './data'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const images = [
  HeaderImage1,
  HeaderImage2,
  HeaderImage3,
  HeaderImage4,
  HeaderImage5
];

const NextArrow = ({ onClick }) => {
  return (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      ❯
    </div>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      ❮
    </div>
  );
};

const Header = () => {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true })
  }, [])

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    centerMode: true, 
    centerPadding: "0px",
    nextArrow: <NextArrow />, // Use custom next arrow
    prevArrow: <PrevArrow />, // Use custom prev arrow
    customPaging: (i) => (
      <div className="custom-dot"></div> // Custom dot
    ),
  responsive: [
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
  };

  return (
    <header id="header">
      <div className="container header__container">
      <div className="header__carousel" data-aos="zoom-in-up">
          <Slider {...settings}>
            {images.map((src, index) => (
              <div key={index} className="carousel-item">
                <img src={src} alt={`Slide ${index + 1}`} className="carousel-image" />
              </div>
            ))}
          </Slider>
        </div>
        <h3 data-aos="zoom-in-up">Thomas Frerichs</h3>
        <p data-aos="zoom-in-up">
          Hey there! I'm a <b>Software Developer</b> and <b>IT Intern</b> from Minnesota who's passionate about technology and creating programs. 
          This is my portfolio where you can see some of my work, learn more about me, and find ways to connect with me.
        </p>
        <div className="header__cta" data-aos="zoom-in-up">
          <a href="#contact" className="btn primary">Let's Talk</a>
          <a href="#portfolio" className="btn light">My Work</a>
        </div>
        <div className="header__socials" data-aos="zoom-in-right">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank"
            rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header
